import apiService from './apiService';

const PREFIX = '/agenda/dates';

async function request(promise) {
  const res = await promise;
  if (!res?.success) {
    throw new Error(res?.message || 'Erreur API');
  }
  return res.data !== undefined ? res.data : res;
}

const agendaDatesService = {
  list({ vue = 'en_cours', q = '', page = 1, perPage = 50, from = '', to = '', tab = '', prix = '', prixMax = '' } = {}) {
    return request(apiService.get(PREFIX, { vue, q, page, perPage, from, to, tab, prix, prixMax }));
  },

  referentiels() {
    return request(apiService.get(`${PREFIX}/referentiels`));
  },

  communes(q) {
    return request(apiService.get(`${PREFIX}/communes`, { q }));
  },

  get(id) {
    return request(apiService.get(`${PREFIX}/${id}`));
  },

  create(payload) {
    return request(apiService.post(PREFIX, payload));
  },

  update(id, payload) {
    return request(apiService.patch(`${PREFIX}/${id}`, payload));
  },

  activer(id) {
    return request(apiService.post(`${PREFIX}/${id}/activer`, {}, {}, { timeout: 180000 }));
  },

  ai(action, payload) {
    return request(apiService.post(`${PREFIX}/ai/${action}`, payload, {}, { timeout: 180000 }));
  },

  medias({ q = '', dir = '' } = {}) {
    return request(apiService.get(`${PREFIX}/medias`, { q, dir }));
  },

  uploadMedia(file) {
    const body = new FormData();
    body.append('file', file);
    return request(apiService.post(`${PREFIX}/medias`, body, {}, { formData: true, timeout: 120000 }));
  },

  cropMedia(payload) {
    return request(apiService.post(`${PREFIX}/medias/crop`, payload, {}, { timeout: 120000 }));
  },

  async downloadMedia(path) {
    const data = await request(apiService.get(`${PREFIX}/medias/download`, { file: path }, { timeout: 120000 }));
    const binary = atob(data.content || '');
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return new Blob([bytes], { type: data.mime || 'application/octet-stream' });
  },
};

export default agendaDatesService;
